import React from 'react';

import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogContentText,
    Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface Props {
    visible: boolean,
    loading: boolean,
    title: string,
    description: string,
    color?: "error" | "inherit" | "primary" | "secondary" | "success" | "info" | "warning",
    onConfirm(): void,
    onHide(): void,
    /** Render as a notice: no Confirm button, only the cancel/close action. */
    hideConfirm?: boolean,
    /** Label for the cancel/close button (default "Cancel"). */
    cancelLabel?: string,
}

const AreYouSureModal: React.FC<Props> = ({
    visible,
    loading,
    title,
    color = 'error',
    description,
    onConfirm,
    onHide,
    hideConfirm = false,
    cancelLabel = 'Cancel',
}) => {
    return (
        <Dialog
            open={visible}
            onClose={onHide}
        >
            <DialogTitle fontWeight={500} textAlign={'left'}>
                {title}
            </DialogTitle>
            <DialogContent sx={{ mt: 1 }}>
                <DialogContentText textAlign={'left'}>
                    {description}
                </DialogContentText>
            </DialogContent>
            <Box sx={{ borderTop: 1, m: 1, p: 1, display: "flex", borderColor: 'divider', background: 'background.default', flexDirection: "row-reverse" }}>
                {!hideConfirm && (
                    <LoadingButton sx={{ ml: 1}} onClick={onConfirm} size='small' autoFocus loading={loading} variant='contained' color={color}>
                        Confirm
                    </LoadingButton>
                )}
                <Button onClick={onHide} disabled={loading} color='inherit' autoFocus={hideConfirm}>
                    {cancelLabel}
                </Button>
            </Box>
        </Dialog>
    )
};

export default AreYouSureModal;